import React, { useState, useEffect, useContext } from "react";
import SimpleCard from "../../components/SimpleCard/SimpleCard";
import { Box, Typography } from "@mui/material";
import { Container, Row, Col } from "react-bootstrap";
import Topbar from "../../components/topbar/Topbar";
import { StateContext } from "../../Context/StateContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./ModerationUser.scss";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ModerationUser = () => {
	const location = useLocation();
	const { id } = useParams();
	const [preparecsv] = useState(false);
	const [buttonOn, setButtonOn] = useState("");
	const [saveButton] = useState(true);
	const [loading, setLoading] = useState(false);
	let { setTopbarHeader, topbarHeader } = useContext(StateContext);
	const token = localStorage.getItem("authToken");
	const navigate = useNavigate();
	const [updatedBy, setUpdatedBy] = useState("");
	const [formData, setFormData] = useState({
		id: "",
		reportedBy: "",
		postedBy: "",
		itemReported: "",
		reason: "",
		reportedDate: "",
		status: "",
		lastUpdated: "",
		location: "",
		reportedByData: null,
		sourceAccountData: null,
		giftData: null
	});

	function formatDate(inputDateStr) {
		let inputDate = new Date(inputDateStr);
		if (isNaN(inputDate.getTime()) || !inputDateStr) {
			const randomDate = new Date(
				Date.now() - Math.floor(Math.random() * 30) * 24 * 60 * 60 * 1000
			);

			inputDate = randomDate;
		}

		const utcDate = new Date(inputDate.getTime() + inputDate.getTimezoneOffset() * 60000);
		const pacificTime = new Date(utcDate.getTime() - 7 * 60 * 60000);

		console.log("UTC Date:", utcDate);
		console.log("Pacific Time:", pacificTime);

		const year = pacificTime.getFullYear().toString();
		const month = (pacificTime.getMonth() + 1).toString().padStart(2, '0');
		const day = pacificTime.getDate().toString().padStart(2, '0');
		const hours = (pacificTime.getHours() % 12 || 12).toString().padStart(2, '0');
		const minutes = pacificTime.getMinutes().toString().padStart(2, '0');
		const ampm = pacificTime.getHours() >= 12 ? "PM" : "AM";

		const formattedDate = `${year}/${month}/${day} ${hours}:${minutes} ${ampm} PT`;

		console.log("Formatted Date:", formattedDate);

		return formattedDate;
	}

	useEffect(() => {
		topbarHeader = "Moderation";
		setTopbarHeader(`${topbarHeader} / Report Details`);
		
		const fetchReportData = async () => {
			// If data is passed via location.state, use it
			if (location.state?.userData) {
				const reportData = location.state.userData;
				document.title = `${reportData.reportedBy} - Cash Wrap`;
				setFormData({
					id: reportData._id,
					reportedBy: reportData?.reportedBy || reportData?.reportedByData?.username || "--",
					postedBy: reportData?.appUser || reportData?.sourceAccountData?.username || "--",
					itemReported: reportData?.reportType || "--",
					reason: reportData?.reason || "--",
					reportedDate: formatDate(reportData?.createdAt) || "--",
					status: reportData?.reportStatus || "--",
					lastUpdated: formatDate(reportData?.lastUpdated) || "--",
					location: reportData?.location || "--",
					reportedByData: reportData?.reportedByData || reportData?.reportedBy,
					sourceAccountData: reportData?.sourceAccountData || reportData?.sourceAccount,
					giftData: reportData?.giftId || reportData?.giftData,
				});
				setButtonOn(reportData.reportStatus || '');
			} else if (id) {
				// Fetch from API if accessing URL directly
				setLoading(true);
				try {
					const response = await axios.get(
						`${process.env.REACT_APP_BASE_URL}/moderation/${id}`,
						{
							headers: {
								Authorization: token,
							},
						}
					);
					const reportData = response.data.data;
					document.title = `${reportData.reportedBy?.username || 'Report'} - Cash Wrap`;
					setFormData({
						id: reportData._id,
						reportedBy: reportData?.reportedBy?.username || "--",
						postedBy: reportData?.sourceAccount?.username || "--",
						itemReported: reportData?.reportType || "--",
						reason: reportData?.reason || "--",
						reportedDate: formatDate(reportData?.createdAt) || "--",
						status: reportData?.reportStatus || "--",
						lastUpdated: formatDate(reportData?.lastUpdated) || "--",
						location: reportData?.location || "--",
						reportedByData: reportData?.reportedBy,
						sourceAccountData: reportData?.sourceAccount,
						giftData: reportData?.giftId,
					});
					setButtonOn(reportData.reportStatus || '');
				} catch (error) {
					console.error("Error fetching report data:", error);
					toast.error("Failed to load report details", {
						position: toast.POSITION.TOP_CENTER,
					});
				} finally {
					setLoading(false);
				}
			}
		};

		fetchReportData();
	}, [id, location.state, token]);

	const statusClick = (label) => {
		setButtonOn(label);
		const userData = localStorage.getItem("userInfo");
		const finalData = JSON.parse(userData);
		setUpdatedBy(finalData.firstName);
	};

	const handleClickSave = () => {
		const user = JSON.parse(localStorage.getItem("userInfo"));
		const userFullName = `${user.firstName} ${user.lastName}`;
		const currentTime = new Date();
		axios
			.patch(
				`${process.env.REACT_APP_BASE_URL}/moderation/${formData?.id}`,
				{
					reportStatus: buttonOn,
					location: userFullName,
					lastUpdated: currentTime,
				},
				{
					headers: {
						Authorization: `${token}`,
					},
				}
			)
			.then((response) => {
				toast.success("Status change saved", {
					position: toast.POSITION.TOP_CENTER,
				});
				navigate("/moderation");
			})
			.catch((error) => {
				console.error("Error updating flag status:", error);
			});
	};

	const onMenuClick = (number) => {
		if (number === "first") {
			navigate(`/app-users/user/${formData.reportedByData?._id}`, {
				state: {
					reportedByData: formData?.reportedByData,
				},
			});
		}
		if (number === "second") {
			navigate(`/app-users/user/${formData.sourceAccountData?._id}`, {
				state: {
					sourceAccountData: formData?.sourceAccountData,
				},
			});
		}
		if (number === "third") {
			// Navigate to the specific gift if gift data exists
			if (formData.giftData?._id) {
				// Prepare gift data in the format expected by Gift component
				const giftDataForNavigation = {
					giftID: formData.giftData._id,
					giftAmount: formData.giftData.giftAmount || "--",
					sender: formData.giftData.giftSender 
						? (formData.giftData.giftSender.username || `${formData.giftData.giftSender.firstName} ${formData.giftData.giftSender.lastName}`)
						: "--",
					recipient: formData.giftData.giftRecipient
						? (formData.giftData.giftRecipient.username || `${formData.giftData.giftRecipient.firstName} ${formData.giftData.giftRecipient.lastName}`)
						: "--",
					privacySetting: "Public", // GiftShare doesn't have privacySetting, defaulting to Public like in Gifts list
					createdAt: formData.giftData.createdAt,
					giftNote: formData.giftData.giftNote || "--",
					giftGIF: formData.giftData.giftGIF || "--",
					giftPhoto: formData.giftData.giftPhoto || formData.giftData.giftGIF || "--",
					recipientTransactionID: formData.giftData.recipientTransactionID || "--",
					senderTransactionID: formData.giftData.senderTransactionID || "--",
					senderData: formData.giftData.giftSender,
					recipientData: formData.giftData.giftRecipient
				};
				navigate(`/gifts/gift/${formData.giftData._id}`, {
					state: {
						userData: giftDataForNavigation
					}
				});
			} else {
				// Fallback to gifts list if no specific gift
				navigate("/gifts");
			}
		}
	};

	if (loading) {
		return (
			<div className="home-container">
				<Navbar />
				<div className="content-container">
					<Sidebar />
					<div className="main-content">
						<Box display="flex" justifyContent="center" alignItems="center" sx={{ minHeight: "50vh" }}>
							<Typography>Loading report details...</Typography>
						</Box>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="home-container">
			<ToastContainer />
			<Navbar />

			<div className="content-container">
				<Sidebar />
				<div className="main-content">
					<div className="topbar-container"></div>
					<div className="main-content">
						<div className="topbar-container">
							<Topbar
								preparecsv={preparecsv}
								saveButton={saveButton}
								handleClickSave={handleClickSave}
							/>
						</div>
						<div className="d-flex">
							<Box display="flex">
								<Container className="mt-5">
									<Row>
										<Col md={6} className="mb-3">
											<SimpleCard
												heading="Reported By"
												data={formData.reportedBy}
												icon={true}
												onMenuClick={() => onMenuClick("first")}
											/>
										</Col>
										<Col md={6} className="mb-3">
											<SimpleCard
												heading="Posted By"
												data={formData.postedBy}
												icon={true}
												onMenuClick={() => onMenuClick("second")}
											/>
										</Col>
									</Row>

									<Row>
										<Col md={6} className="mb-3 d-flex">
											<SimpleCard
												heading="Item Reported"
												data={formData.itemReported}
												icon={true}
												onMenuClick={() => onMenuClick("third")}
											/>
										</Col>
										<Col md={6} className="mb-3">
											<SimpleCard
												heading="Reason For Report"
												data={formData.reason}
											/>
										</Col>
									</Row>

									<Row>
										<Col md={6} className="mb-3">
											<SimpleCard
												heading="Reported On"
												data={formData.reportedDate}
											/>
										</Col>
										<Col md={6} className="mb-3">
											<SimpleCard
												heading="Status"
												data={
													<Box>
														<Box display="flex" justifyContent="space-evenly">
															<button
																className={
																	buttonOn === "Pending Review"
																		? "onButton"
																		: "offButton"
																}
																onClick={() => statusClick("Pending Review")}
															>
																Pending
															</button>
															<button
																className={
																	buttonOn === "Ignored"
																		? "onButton"
																		: "offButton"
																}
																onClick={() => statusClick("Ignored")}
															>
																Ignored
															</button>
															<button
																className={
																	buttonOn === "Confirmed"
																		? "onButton"
																		: "offButton"
																}
																onClick={() => statusClick("Confirmed")}
															>
																Confirmed
															</button>
														</Box>

														<Box pt={1}>
															<Typography style={{ fontSize: "15px" }}>
																{updatedBy
																	? `Updated by ${formData?.location} on ${formData?.lastUpdated}`
																	: null}
															</Typography>
														</Box>
													</Box>
												}
											/>
										</Col>
									</Row>

									{/* User Details Section */}
									{(formData.reportedByData || formData.sourceAccountData) && (
										<Row>
											<Col md={12} className="mb-3">
												<Box sx={{ p: 2, backgroundColor: "#f5f5f5", borderRadius: 2 }}>
													<Typography variant="h6" sx={{ mb: 2 }}>User Details</Typography>
													<Row>
														{formData.reportedByData && (
															<Col md={6} className="mb-2">
																<Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>Reported By User:</Typography>
																<Typography>Name: {formData.reportedByData?.firstName} {formData.reportedByData?.lastName}</Typography>
																<Typography>Username: {formData.reportedByData?.username || "--"}</Typography>
																<Typography>Email: {formData.reportedByData?.email || "--"}</Typography>
																<Typography>Phone: {formData.reportedByData?.phoneNo?.number || "--"}</Typography>
																<Typography>Status: {formData.reportedByData?.userStatus || "--"}</Typography>
																<Typography>Verified: {formData.reportedByData?.verifiedUser || "--"}</Typography>
																{/* <Typography>Gifts Sent: {formData.reportedByData?.giftsSent || 0}</Typography>
																<Typography>Gifts Received: {formData.reportedByData?.giftsReceived || 0}</Typography>
																<Typography>Balance: ${formData.reportedByData?.balance || 0}</Typography> */}
															</Col>
														)}
														{formData.sourceAccountData && (
															<Col md={6} className="mb-2">
																<Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>Reported User:</Typography>
																<Typography>Name: {formData.sourceAccountData?.firstName} {formData.sourceAccountData?.lastName}</Typography>
																<Typography>Username: {formData.sourceAccountData?.username || "--"}</Typography>
																<Typography>Email: {formData.sourceAccountData?.email || "--"}</Typography>
																<Typography>Phone: {formData.sourceAccountData?.phoneNo?.number || "--"}</Typography>
																<Typography>Status: {formData.sourceAccountData?.userStatus || "--"}</Typography>
																<Typography>Verified: {formData.sourceAccountData?.verifiedUser || "--"}</Typography>
																{/* <Typography>Gifts Sent: {formData.sourceAccountData?.giftsSent || 0}</Typography>
																<Typography>Gifts Received: {formData.sourceAccountData?.giftsReceived || 0}</Typography>
																<Typography>Balance: ${formData.sourceAccountData?.balance || 0}</Typography> */}
															</Col>
														)}
													</Row>
												</Box>
											</Col>
										</Row>
									)}

									{/* Gift Details Section */}
									{formData.giftData && (
										<Row>
											<Col md={12} className="mb-3">
												<Box sx={{ p: 2, backgroundColor: "#f5f5f5", borderRadius: 2 }}>
													<Typography variant="h6" sx={{ mb: 2 }}>Gift Details</Typography>
													<Typography>Gift Amount: ${formData.giftData?.giftAmount || "--"}</Typography>
													{/* <Typography>Fee Charged: ${formData.giftData?.feeCharged || "--"}</Typography> */}
													{formData.giftData?.giftNote && (
														<Typography>Note: {formData.giftData.giftNote}</Typography>
													)}
													{formData.giftData?.giftSender && (
														<Typography>Sender: {formData.giftData.giftSender?.firstName} {formData.giftData.giftSender?.lastName} ({formData.giftData.giftSender?.username})</Typography>
													)}
													{formData.giftData?.giftRecipient && (
														<Typography>Recipient: {formData.giftData.giftRecipient?.firstName} {formData.giftData.giftRecipient?.lastName} ({formData.giftData.giftRecipient?.username})</Typography>
													)}
													{formData.giftData?.createdAt && (
														<Typography>Gift Sent On: {formatDate(formData.giftData.createdAt)}</Typography>
													)}
												</Box>
											</Col>
										</Row>
									)}
								</Container>
							</Box>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ModerationUser;
